export enum UserFlags {
  inAutomatedPayouts = 'in-automated-payouts',
}

export enum EnvFlags {
  paymentRequestOnTalk = 'paymentRequestOnTalk',
  paymentRequestIdealForm = 'paymentRequestIdealForm',
  paymentRequestSCAPayments = 'paymentRequestSCAPayments',
  mediaQueryNext = 'mediaQueryNext',
  blogArticlePageNext = 'blogArticlePageNext',
}
